import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

const HeroHeading = () => (
  <>
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-emerald-500/20 to-green-500/20 border border-emerald-500/30 text-emerald-400 rounded-full text-sm font-medium mb-8 backdrop-blur-sm"
    >
      <Sparkles className="w-4 h-4" />
      Spezialisiert auf Wohnungsabgaben in Zürich
    </motion.div>

    <motion.h1
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="text-5xl md:text-7xl lg:text-8xl font-bold mb-6 leading-tight"
    >
      <span className="text-white">Maler Zürich zum</span>
      <br />
      <span className="bg-gradient-to-r from-blue-400 via-blue-500 to-purple-500 text-transparent bg-clip-text animate-gradient">
        Fixpreis
      </span>
      <br />
      <span className="text-white/90 text-4xl md:text-5xl">ab CHF / m²</span>
    </motion.h1>

    <motion.p
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.4 }}
      className="text-xl md:text-2xl text-slate-300 mb-10 leading-relaxed max-w-3xl mx-auto"
    >
      Wohnung streichen beim Auszug oder Einzug? Wir streichen leere und möblierte Wohnungen schnell, sauber und professionell – zum fairen Fixpreis.
    </motion.p>
  </>
);

export default HeroHeading;
